import ScansGroupedReport from "./ScansGroupedReport";

export default function ScanByCountry() {
  return (
    <ScansGroupedReport
      title="Scan by Country"
      subtitle="Scans grouped by the country of the scanned QR / fuel access's retail outlet."
      dimension="country"
      dropdownLabel="Country"
      dropdownPlaceholder="All countries"
      dropdownApiPath="/master/countries"
    />
  );
}
